<template>
    <!-- if value corrected, show corrected value alongside original value, with attribution -->
    <span v-if="correctedText">
        <!-- | marks are used to distringuish original and corrected values in json_pdf -->
        <span id="resInfoCorrected" :style="{ display: 'none' }">{{ originalTextPrint }}||{{ correctedText }}|||</span>
        <strike>{{ originalText }}</strike> {{ correctedText }}
    </span>
    <!-- otherwise show original value with attribution  -->
    <span v-else>{{ originalText }}</span>
</template>

<script>
import { getLatestLogFieldValue, getLogFieldValue } from '@/services/logService';
export default {
    props: {
        fieldArray: {
            type: Array,
            required: true
        },
        logType: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            getLatestLogFieldValue,
            getLogFieldValue
        };
    },
    computed: {
        arrayLength() {
            return (this.fieldArray && this.fieldArray.length) || 0;
        },
        correctedText() {
            return (this.arrayLength > 1 && this.getLatestLogFieldValue(this.fieldArray, true)) || '';
        },
        originalText() {
            return (this.arrayLength && this.getLogFieldValue(this.fieldArray[0], this.logType === 'take_out')) || '';
        },
        originalTextPrint() {
            return (
                (this.arrayLength && this.getLogFieldValue(this.fieldArray[0], this.logType === 'take_out', true)) || ''
            );
        }
    }
};
</script>
